import React, { useEffect } from 'react';

export default function LandBotPage() {
    useEffect(() => {
        new window.Landbot.Fullpage({
            configUrl: 'https://chats.landbot.io/v3/H-1206689-9W9MQ1EMEEYQS0OX/index.json',
        });
    }, []);
    return (<div />);
}